import React, { Fragment } from 'react';
import { H6, P, UL, LI, Btn, Image, H5 } from '../../../../AbstractElements';
import { Card, Col, CardBody, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import JobDescription from './jobDescription';
import CardsClass from '../../JobCardView/Cards';

const MainCard = () => {
  return (
    <Fragment>
      <Col xxl='9' xl='8' className='box-col-70'>
        <Card>
          <div className='job-search'>
            <CardBody>
              <div className='d-sm-flex align-items-start'>
                <Image className='img-40 img-fluid mx-auto m-sm-r-20' src={require('../../../../assets/images/job-search/1.jpg')} alt='' />
                <div className='flex-grow-1'>
                  <H6 className='f-w-600'>
                    <a href='#javascript'>Product Designer (UI/UX Designer)</a>
                  </H6>
                  <P>Endless - United States</P>
                  <UL className='rating d-inline-flex simple-list gap-1'>
                    <LI>
                      <i className='m-0 fa fa-star font-warning'></i>
                    </LI>
                    <LI>
                      <i className='m-0 fa fa-star font-warning'></i>
                    </LI>
                    <LI>
                      <i className='m-0 fa fa-star font-warning'></i>
                    </LI>
                    <LI>
                      <i className='m-0 fa fa-star font-warning'></i>
                    </LI>
                    <LI>
                      <i className='m-0 fa fa-star font-warning'></i>
                    </LI>
                  </UL>
                  <Link to={`${process.env.PUBLIC_URL}/job-search/job-apply`}>
                    <Btn className='btn btn-sm job-apply-btn' color='primary'>
                      Apply for this job
                    </Btn>
                  </Link>
                </div>
              </div>
              <JobDescription />
            </CardBody>
          </div>
        </Card>
        <div className='header-faq'>
          <H5 className='mb-0 f-w-600'>Similar jobs</H5>
        </div>
        <Row>
          <CardsClass limit={5} jobClass={'col-xl-6 xl-100 box-col-12'} ribbion={false} col12={true} />
        </Row>
      </Col>
    </Fragment>
  );
};

export default MainCard;
